<template>
  <div class="related-wares">
    <hr />

    <h2 class="uppercase px-2 text-center more-wares">
      <vue-link to="/shop#products">More Wares</vue-link>
    </h2>

    <gallery class="gallery">
      <product-gallery-item v-for="product in productsToShow" :key="product.id" :product="product" />
    </gallery>
  </div>
</template>

<script>
import { getCollection } from '@/lib/shopify-utils'
import Gallery from '@/components/Gallery'
import ProductGalleryItem from '@/components/ProductGalleryItem.vue'

export default {
  name: 'ProductGrid',
  components: {
    Gallery,
    ProductGalleryItem,
  },
  props: {
    collectionId: String,
    excludeByHandle: Array,
  },
  data() {
    return {
      products: [],
    }
  },
  computed: {
    productsToShow() {
      return this.products.filter((product) => !this.excludeByHandle.includes(product.handle))
    },
  },
  async mounted() {
    if (this.collectionId) {
      // un base64 encode the collection id
      const decodedCollectionId = atob(this.collectionId)

      const collection = await getCollection({ collectionId: decodedCollectionId })

      if (collection.data) {
        this.products = collection.data.collection.products.nodes
      }
    }
  },
}
</script>

<style scoped>
/**
 * Gallery
 */

.related-wares {
  padding-top: 8rem;
}

.related-wares hr {
  margin-bottom: 3rem;
}

.related-wares .more-wares {
  margin-bottom: 3.2rem;
}

.gallery {
  white-space: nowrap;
  overflow-x: scroll;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}

.gallery::-webkit-scrollbar {
  width: 0px;
  height: 0px;
  background: transparent;
}
</style>
